import React from 'react';
import {Pressable, StatusBar, StyleSheet, Text, View} from 'react-native';
import {useIsFocused} from '@react-navigation/native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import ChevronLeft from '../assets/icons/chevron-left.svg';
import {colors, fonts} from '../config/theme';

// Solid forest title bar for the auth forms. It runs up under the status
// bar, so it flips the status bar to light content while its screen is
// focused (App.js sets dark content globally).
// style: extra styles for the bar (e.g. rounded bottom corners).
const AuthHeader = ({title, onBack, style}) => {
  const insets = useSafeAreaInsets();
  const isFocused = useIsFocused();
  return (
    <View style={[styles.bar, {paddingTop: insets.top}, style]}>
      {isFocused ? (
        <StatusBar barStyle="light-content" backgroundColor={colors.primary} />
      ) : null}
      <View style={styles.row}>
        {onBack ? (
          <Pressable
            onPress={onBack}
            hitSlop={8}
            accessibilityRole="button"
            accessibilityLabel="Go back"
            style={({pressed}) => [styles.back, pressed && styles.pressed]}>
            <ChevronLeft width={24} height={24} color={colors.onPrimary} />
          </Pressable>
        ) : null}
        <Text style={styles.title} numberOfLines={1} accessibilityRole="header">
          {title}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    backgroundColor: colors.primary,
  },
  row: {
    height: 56,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 56,
  },
  back: {
    position: 'absolute',
    left: 12,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  pressed: {
    opacity: 0.7,
    transform: [{scale: 0.95}],
  },
  title: {
    fontFamily: fonts.bold,
    fontSize: 19,
    lineHeight: 24,
    letterSpacing: -0.4,
    color: colors.onPrimary,
  },
});

export default AuthHeader;
